import { Input } from "@acdc2/ui/components/input";
import { useTranslation } from "react-i18next";
import { ValueMissingFormMessage } from "../../ui/forms";
import {
  FormControl,
  FormField,
  FormLabel,
} from "@acdc2/ui/components/access-form";

type Props = React.ComponentProps<typeof Input>;

export function TableCellColumnSpanFormField(props: Props) {
  const { t } = useTranslation();

  return (
    <FormField name="tableCellColumnSpan">
      <FormLabel>{t("TableCellColumnSpanFormField.label")}</FormLabel>
      <FormControl asChild>
        <Input
          placeholder={t("TableCellColumnSpanFormField.placeholder")}
          type="number"
          inputMode="numeric"
          min={1}
          required
          {...props}
        />
      </FormControl>
      <ValueMissingFormMessage />
    </FormField>
  );
}
